<template>
  <div id="main-layout">
    <Navigation>
      <transition name="slide-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </Navigation>
  </div>
</template>

<style>
#main-layout {
  width: 100%;
  height: 100vh;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.md-table {
  text-align: left;
}

.md-dialog {
  width: 500px;
  padding: 30px;
  max-height: 50vh;
  overflow: auto !important;
}
.md-dialog-title {
  padding: 0 !important;
  height: 40px;
}
.md-dialog-title.md-title {
  line-height: 40px;
}
.md-dialog-title .md-button {
  float: right;
}
</style>

<script>
import Navigation from "../components/Navigation";

export default {
  components: {
    Navigation
  }
};
</script>
